export enum CompletionStatusEnum {
  NotStarted = 0,
  InProgress,
  Completed,
}
